import * as React from "react"
import * as i18n from "tb-i18n"
import { getGlobalConfig } from "../../lib/global-config"
import CustomTitle from "./custom-title"
import { AppsDownload } from "./apps-download/index"
import CustomerCarousel from "./customer-carousel"
import {
    getCustomerCarouselData,
    getCustomerWallData,
    getProductsMatrixData,
    getProjectTypeData,
    getCustomerCaseUrl
} from "./homepage.module"
import IntroScreen from "./intro-screen"
import LogoWall from "./logo-wall"
import ProductMatrix from "./product-matrix"
import ProjectTypeWall from "./project-type-wall"
import SignUpPanel from "./sign-up-panel"
import { findDOMNode } from "react-dom"
import { getTransformStyle } from "../../lib/util"
require("./homepage.component.styl")

interface Props { }
export default class Homepage extends React.PureComponent<Props> {
    private homepage: Element
    private mobileWidth = 768
    private scrollY: number = 0

    constructor(props: Props) {
        super(props)
        this.state = {
            scrollY: 0
        }
    }

    onClickFreeTry = () => {
        const URL = getGlobalConfig().configUrl
        window.open(`${URL["ACCOUNT_HOST"]}/signup?from=homepage`)
    }

    onClickDownload = () => {
        window.location.href = "/apps"
    }

    onClickEnter = () => {
        window.location.href = "/projects"
    }

    componentDidMount() {
        const pageNode = document.getElementById("homepage-react")
        if (pageNode) {
            pageNode.classList.remove("is-loading")
        }

        document.body.classList.add("background-transparent")
        if (window.innerHeight > this.mobileWidth) {
            window.addEventListener("scroll", this.handleScroll)
        }
        window.addEventListener("scroll", this.navbarListener)
    }

    render() {
        const { scrollY } = this
        const circleLeftStyle = {
            ...getTransformStyle(`translate3d(0, ${scrollY * 0.15}px, 0)`)
        }
        const circleRightStyle = {
            ...getTransformStyle(`translate3d(0, ${scrollY * 0.1}px, 0)`)
        }

        const refFn = ref => {
            this.homepage = findDOMNode(ref) as Element
        }
        return (
            <div className="homepage" ref={ refFn }>
                <div
                    className="homepage-circle homepage-circle-left"
                    style={ circleLeftStyle }
                />
                <div
                    className="homepage-circle homepage-circle-right"
                    style={ circleRightStyle }
                />
                <IntroScreen />
                <CustomTitle>{i18n.get("homepage.title.1")}</CustomTitle>
                <ProductMatrix list={ getProductsMatrixData() } />

                <CustomTitle> {i18n.get("homepage.title.2")}</CustomTitle>
                <ProjectTypeWall data={ getProjectTypeData() } />

                <CustomTitle> {i18n.get("homepage.title.3")}</CustomTitle>
                <CustomerCarousel data={ getCustomerCarouselData() } />
                <LogoWall logos={ getCustomerWallData() } />
                <div className="view-story-link">
                    <a href={ getCustomerCaseUrl() } target="_blank">
                        {i18n.get("homepage.theyHowToUse")}
                        <i className="icon icon-chevron-right" />
                    </a>
                </div>
                <AppsDownload />
                <SignUpPanel />
            </div>
        )
    }

    handleScroll = () => {
        const scrollY = window.scrollY || window.pageYOffset
        if (scrollY > window.outerHeight) {
            return
        }
        this.scrollY = scrollY
    }

    navbarListener = () => {
        const scrollY = window.scrollY || window.pageYOffset
        if (scrollY > 0) {
            document.body.classList.remove("background-transparent")
            document
                .getElementsByTagName("header")[0]
                .classList.add("with-bottom-border")
        } else {
            document.body.classList.add("background-transparent")
            document
                .getElementsByTagName("header")[0]
                .classList.remove("with-bottom-border")
        }
    }
}
